export default "__VITE_ASSET__Bw$bU_Az__"